import { getSearchParam } from "@/utils";
function getSubDomain() {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return "";
  }
  const parts = hostname.split(".");
  if (parts.length > 2) {
    return parts.slice(0, -2).join(".");
  }
  return "";
}
export default function useSubdomain() {
  let subdomain = getSearchParam("subdomain");
  const domain = getSearchParam("domain") || window.location.hostname;
  if (!subdomain) {
    subdomain = getSubDomain();
  }
  return { subdomain, domain };
}
